import { useI18n } from "../i18n/useI18n"
import { getRemoteSyncState } from "./syncState"

type SyncTrackedRecord = {
  remoteSyncConflictAt?: string
  remoteSyncFailedAt?: string
  remoteSyncedAt?: string
}

export function RecordOriginBadge({ record }: { record: SyncTrackedRecord }) {
  const { t } = useI18n()
  const state = getRemoteSyncState(record)
  if (state === "synced" || state === "failed") return null
  const origin = state === "conflict" ? "conflict" : "local"
  return (
    <span className={`record-origin-badge record-origin-badge-${origin}`}>
      {origin === "conflict"
        ? t("table.sync.conflict")
        : t("table.origin.local")}
    </span>
  )
}

export function LibraryRefreshStatus({
  failed,
  lastRefreshedAt,
}: {
  failed: boolean
  lastRefreshedAt: string | null
}) {
  const { locale, t } = useI18n()
  const offline = typeof navigator !== "undefined" && navigator.onLine === false

  let label = t("table.refresh.idle")
  let tone = "idle"

  if (offline) {
    label = t("table.refresh.offline")
    tone = "offline"
  } else if (failed) {
    label = t("table.refresh.failed")
    tone = "failed"
  } else if (lastRefreshedAt) {
    label = t("table.refresh.last", {
      time: new Intl.DateTimeFormat(locale, {
        hour: "numeric",
        minute: "2-digit",
        month: "short",
        day: "numeric",
      }).format(new Date(lastRefreshedAt)),
    })
    tone = "synced"
  }

  return (
    <p className={`table-refresh-status table-refresh-status-${tone}`}>
      {label}
    </p>
  )
}
